import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Lifepath.me is the shiniest web thing",
  "description": "",
  "published": "2011-06-17T00:00:00.000Z",
  "redirect_from": ["/blog/lifepath-me-is-the-shiniest-web-thing/swizec/1848"],
  "categories": "Dustin Curtis, Life expectancy, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://lifepath.me/swizec"
      }}>{`Lifepath.me`}</a>{` is a very simple service that gives your life a progress bar. Nothing too spectacular there, at its core, it's really just a visualisation of some statistics data from around the world about the sort of life expectancy people have in your neck of the woods and such.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/06/pvYVB4.png",
        "alt": null
      }}></img>{`I found the service by accident when I was `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/my-footer-gives-you-a-glimpse-into-my-life/swizec/1840",
        "title": "My new footer gives you a glimpse into my life"
      }}>{`making my shiny footer `}</a>{`and was looking at `}<a parentName="p" {...{
        "href": "http://dustincurtis.com/",
        "title": "Dustin Curtis"
      }}>{`Dustin Curtis`}</a>{`' blog for inspiration. His latest post right about then was about some american president or another and it was displaying the lifepath.me embed.`}</p>
    <p>{`As soon as I saw the website I wanted an account, possibly because I was already looking for a way to display all that info on my site, or maybe because it was just so shiny. Well the thing is invite only and the only, but you can buy an account by entering your credit card info.`}</p>
    {
      /* more */
    }
    <p>{`Because entering credit card info into random web forms is against my policy my knee jerk reaction was to start begging around the internets trying to find someone who can give me an invite. Why I didn't just think of sending @dcurtis an email ... well it didn't occur to me. Luckily I finally found someone with an invite on HackerNews' Convore channel - It was @dcurtis himself.`}</p>
    <p>{`Getting the invite was cause for jubilation. But going through the registration spiel ... my, it was just the most beautiful thing ever. I have never felt such joy at the filling out of some web forms and divulging my information. Unfortunately I can't show you what the process looks like anymore, but I can show you this ... the login form.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/06/Vdo2i4.png",
        "alt": null,
        "title": "The login form"
      }}></img></p>
    <p>{`You just know a service that says Welcome Back on its login form knows what it's doing. But you know what, I should stop talking, here are some more shiny pictures.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/06/pvYVB4.png",
        "alt": null,
        "title": "Right after login"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/06/QEj894.png",
        "alt": null,
        "title": "The start of my path"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/06/TkHsM4.png",
        "alt": null,
        "title": "Near the end I will be old"
      }}></img></p>
    <p>{`Although I think lifepath.me does serve a good reason beyond just being shiny. It's facing you with the fact that such and such percentage of your life is already behind you and that maybe you should ask yourself whether you're spending this time being as awesome as you can be.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/my-footer-gives-you-a-glimpse-into-my-life/swizec/1840"
        }}>{`My new footer gives you a glimpse into my life`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.aweber.com/blog/email-marketing/4-best-practices-for-web-forms.htm"
        }}>{`4 Best Practices for Web Forms`}</a>{` (aweber.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://pathleader.wordpress.com/2010/04/10/the-maui-path-a-lifepath-to-happiness/"
        }}>{`The Maui Path, a lifepath to Happiness`}</a>{` (pathleader.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=bf690755-23c5-4f42-8355-89e47f31d703",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      